module.exports = __webpack_public_path__ + "img/twitter.17875a5b.svg";